import { Controller } from "remult";

@Controller("call-center-faq-item-methods")
export class CallCenterFaqItemMethods {}
